const CLASSES = {
    wrapper: "VoltComponents-ButtonWrapper",
};

export { CLASSES };
//# sourceMappingURL=classes.js.map
